import styled from "styled-components";

const EPtoSc = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 10px auto;
  border-radius: 8px;
  gap: 0.8rem;
  width: 98vw;
  position: absolute;
  top: 50px;
  padding: 10px;
  flex-direction: column;

  table {
    /* width: 100%; */
    border-collapse: collapse;
  }

  th.heading {
    font-weight: bold;
    background-color: #3917b3;
    /* padding: 10px; */
    text-align: center;
  }

  td {
    padding: 10px;
    border-bottom: 1px solid #ddd;
    text-align: center;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover {
    background-color: #f9f9f9;
  }
`;

export default EPtoSc;
